export default __webpack_public_path__ + "static/media/Employee-Directory-React.8309b4ea.png";